import { Component, OnInit, Inject } from '@angular/core';
import { IPopup } from 'src/app/services/popup/popup-ref';
import { DATA, POPUP } from 'src/app/services';
import { SnippetManagerData } from './snippet-manager-data';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IValueTemplate, IValueTemplateFilter, ValueTemplateService } from 'src/app/xena-api';

@Component({
    selector: 'app-snippet-manager',
    templateUrl: './snippet-manager.component.html',
    styleUrls: ['./snippet-manager.component.scss'],
    standalone: false
})

export class SnippetManagerComponent implements OnInit {
  templates: IValueTemplate[] = [];
  isLoading = true;
  isSaving = false;
  key: string;
  keyTitle: string;
  multiLines: boolean;

  templatesMarkedForDeletion: IValueTemplate[] = [];

  constructor(@Inject(POPUP) private popup: IPopup,
    @Inject(DATA) data: SnippetManagerData,
    private valueTemplateService: ValueTemplateService) {
    this.key = data.key;
    this.keyTitle = data.keyTitle;
    this.multiLines = data.multiLines;
  }

  ngOnInit(): void {
    if (!this.key) { throw new Error($localize`:@@snippetManagerNoKeyError:No snippet key available for snippet-manager-component (xwc).`); }
    this.loadTemplates();
  }

  loadTemplates(): void {
    const filter: IValueTemplateFilter = {
      key: this.key,
      forceNoPaging: true
    };
    this.valueTemplateService.list(filter).subscribe(results => {
      this.templates = results.entities;
      this.isLoading = false;
    });
  }

  private removeTemplate(template: IValueTemplate): void {
    const index = this.templates.indexOf(template);
    if (index > -1) { this.templates.splice(index, 1); }
  }

  deleteTemplate(template: IValueTemplate): void {
    if (template.id) {
      this.templatesMarkedForDeletion.push(template);
    }
    this.removeTemplate(template);
  }

  addTemplate(): IValueTemplate {
    const template: IValueTemplate = { key: this.key, content: '' };
    this.templates.push(template);
    return template;
  }

  save(): void {
    this.isSaving = true;

    const saveRequests = this.templates.map((template, i) =>
      this.valueTemplateService.save(template).pipe(
        map(t => {
          this.templates[i] = t;
          return true;
        }),
        catchError(e => of(false))
      )
    );

    const deleteRequests = this.templatesMarkedForDeletion.map((template) =>
      this.valueTemplateService.delete(template).pipe(
        map(() => true),
        catchError(er => of(false))
      )
    );

    forkJoin([...saveRequests, ...deleteRequests, of(true)])
      .subscribe(sr => {
        this.isSaving = false;
        if (sr.every(r => r)) { this.close(); }
      });
  }

  close(): void {
    this.popup.close();
  }
}
